import { PublicTenantIdentifierInfoContract } from 'models'
import { IAction } from 'types/storeTypes'

export const SET_TENENT_INFO = 'SET_TENENT_INFO'

export interface ITenantIdentifierInfoState {
    data: PublicTenantIdentifierInfoContract
}

export const tenantIdentifierInfoInitialState: ITenantIdentifierInfoState = {
    data: {},
}

function tenantIdentifierInfo(
    state: ITenantIdentifierInfoState = tenantIdentifierInfoInitialState,
    action: IAction,
): ITenantIdentifierInfoState {
    const { payload, type } = action
    switch (type) {
        case SET_TENENT_INFO:
            return {
                ...state,
                data: payload,
            }
        default:
            return state
    }
}

export default tenantIdentifierInfo
